import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Admin } from "@/lib/types/finsey/user";


const initialState: Admin = {
    email: '',
    label: [],
    name: '',
    prefs: {title: ''}
};

export const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setAdminData: (state, actions: PayloadAction<any>) => {
            state.email = actions.payload.email
            state.label = actions.payload.label
            state.name = actions.payload.name
            state.prefs = actions.payload.prefs
        }
    },
});

export const { setAdminData } = adminSlice.actions;
export default adminSlice;
